import { render } from "./ButtonActive.vue?vue&type=template&id=8043d382"
import script from "./ButtonActive.vue?vue&type=script&lang=js"
export * from "./ButtonActive.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__